//node_modules
import { useState } from "react";
import AOS from "aos";
//pages
import Main from "./pages/Main";
import { Toaster } from "react-hot-toast";
import "aos/dist/aos.css";

function App() {
  AOS.init({
    delay: 200,
    once: true,
  });

  const [currentLang, setCurrentLang] = useState("tr");
  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 7000,
        }}
      />
      <Main currentLang={currentLang} setCurrentLang={setCurrentLang} />
    </div>
  );
}

export default App;
